import { PRIVACY_POLICY_STATIC_PAGE_SLUG } from '@/logic/staticPage/staticPage.constants';
import { client } from '@/network/client';
import { StaticScreen } from '@/screens/StaticScreen';
import { getMessages } from '@/utils/messages.utils';

export default StaticScreen;

export const getStaticProps = async () => {
  const { data, error } = await client.GET('/api/v1/core/static_pages/{slug}', {
    params: {
      path: {
        slug: PRIVACY_POLICY_STATIC_PAGE_SLUG,
      },
    },
  });

  if (error) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      messages: await getMessages(),
      data,
    },
  };
};
